var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.componentName)?_c('section',{staticClass:"module"},[_c('section',{staticClass:"module-main"},[_c('AppPanel',{attrs:{"hideHeader":""}},[_c('section',{staticClass:"module-wrapper"},[_c(_vm.componentName,{tag:"component"})],1)])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }